import { render, staticRenderFns } from "./ArrivalCount.vue?vue&type=template&id=41f58d5e&scoped=true&"
import script from "./ArrivalCount.vue?vue&type=script&lang=js&"
export * from "./ArrivalCount.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalCount.vue?vue&type=style&index=0&id=41f58d5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f58d5e",
  null
  
)

export default component.exports